import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoObjectTbmModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoObjectTbmModel._instance == null) GeoObjectTbmModel._instance = new GeoObjectTbmModel(authManager);
        return GeoObjectTbmModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-object-tbms');

        this.entityName = 'model-sections.GeoObjectTbm';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Object Tbm';
        this.setLabel = 'Object Tbms';

        this.browser = {
            name: 'default-model-sections-geoobjecttbm-browser',
            moduleName: 'default-model-sections-geoobjecttbm-browser',
            moduleTitle: 'Object Tbms',
            moduleStateSlotName: 'default-model-sections-geoobjecttbm-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoobjecttbm-editor',
            moduleName: 'default-model-sections-geoobjecttbm-editor',
            moduleTitle: 'Object Tbm',
            moduleStateSlotName: 'default-model-sections-geoobjecttbm-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: false,
                label: 'Geo Section',
                description: 'geoLayer odpovídá vždy jen jedné geoSection, n:1',
                readOnly: true,
            },
            {
                name: 'objectTypeId',
                type: 'GeoObjectType',
                persistent: true,
                label: 'Object Type',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'elevationTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'thickness',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Thickness',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationOfZeroDatumLevel',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Elevation Of Zero Datum Level',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Vertical Level Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Vertical Level Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'axisElevation',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Axis Elevation',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'excavationDiameter',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Excavation Diameter',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'slope',
                type: 'float',
                persistent: true,
                unit: '%',
                label: 'Slope',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'coordinateXStart',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Coordinate X Start',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tunnelOrientationTypeId',
                type: 'TunnelOrientationType',
                persistent: true,
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
